module.exports = __webpack_public_path__ + "od-warranty/od-warranty-d91e2afcb850080998bf65c5a27aa618.svg";